/**
 * @description - _preview-slider.js: Preview sliders handling
 *
 * @author - Ruud Timmermans <r.timmermans@bluedragon.nl>
 */

import { tns } from 'tiny-slider/src/tiny-slider';
import '../../../node_modules/tiny-slider/src/tiny-slider.scss';

const sliderContainerClass = 'c-preview';

/**
 * @description - Add the correct classnames to the buttons
 *
 * @param {object} slider - the slider object
 */
function addSliderBtnClasses(slider) {
    const btnClass = `${sliderContainerClass}__btn`;
    slider.prevButton.className = `${btnClass} ${btnClass}--prev`;
    slider.nextButton.className = `${btnClass} ${btnClass}--next`;
}

/**
 * @description - Set the big preview image
 *
 * @param {object} slider - the slider object
 * @param {object} sliderHolder - the slider container
 */
function setPreviewImage(slider, sliderHolder) {
    const currentSlide = slider.slideItems[slider.index];
    const imgObject = sliderHolder.closest(`.${sliderContainerClass}`).querySelector('.js-preview__img');
    imgObject.src = currentSlide.dataset.urlBig;
    imgObject.dataset.originalImg = currentSlide.dataset.originalImg;
}

/**
 * @description - sets the correct slide active by using button controls
 *
 * @param {object} slider - the slider object
 * @param {object} sliderHolder - the slider container
 */
function setSlideActive(slider, sliderHolder) {
    const activeClass = `${sliderContainerClass}__slide--active`;

    for (const slide of slider.slideItems) {
        slide.classList.remove(activeClass);
    }

    slider.slideItems[slider.index].classList.add(activeClass);
    setPreviewImage(slider, sliderHolder);
}

/**
 * @description - sets the slide active by data-index (clicking slide)
 *
 * @param {object} slider - the slider object
 * @param {object} sliderHolder - the slider container
 * @param {number} index - the index of the slide to be active
 */
function setSlideIndexActive(slider, sliderHolder, index) {
    const activeClass = `${sliderContainerClass}__slide--active`;

    for (const slide of slider.slideItems) {
        slide.classList.remove(activeClass);

        if (slide.dataset.index === index) {
            slide.classList.add(activeClass);

            const imgObject = sliderHolder.closest(`.${sliderContainerClass}`).querySelector('.js-preview__img');
            imgObject.src = slide.dataset.urlBig;
            imgObject.dataset.originalImg = slide.dataset.originalImg;
        }
    }
}

// Get all the sliders on the page
const previewSlidersHolders = document.querySelectorAll('.js-preview-slider');

if (previewSlidersHolders.length > 0) {
    // init each slider
    previewSlidersHolders.forEach((sliderHolder) => {
        // Init the slider
        const slider = tns({
            container: sliderHolder,
            nav: false,
            autoplay: false,
            autoplayButton: false,
            items: 4,
            gutter: 10,
            controls: true,
            controlsText: ['', '']
        });

        const sliderInfo = slider.getInfo();

        // Add custom handling
        addSliderBtnClasses(sliderInfo, sliderHolder);
        setSlideActive(sliderInfo, sliderHolder);

        // Attach event listners
        for (const slide of sliderInfo.slideItems) {
            slide.addEventListener('click', () => {
                slider.goTo(slide.dataset.index);
                const index = slide.dataset.index;
                setSlideIndexActive(sliderInfo, sliderHolder, index);
            });
        }

        slider.events.on('indexChanged', () => {
            setSlideActive(slider.getInfo(), sliderHolder);
        });
    });
}
